import TicketList from "apps/registration/components/ticket";
import Icon from "assets/icons";
import { ErrorMessage } from "formik";
import { AnyObject } from "global";
import React from "react";
import Button from "shared/components/button";
import ButtonType from "shared/enums/ButtonTypes";
import Variant from "shared/enums/Variant";
import FormContainer from "shared/form";
import FormTextField from "shared/form/fields/textField";
import { useCopies } from "shared/hooks/useCopies";
import { useCouponCodeService } from "./service";
import { CouponCodeFormProps, CouponCodeReadOnlyProp } from "./type";
import RegistrationFooter from "apps/registration/components/registrationFooter";
import NoTicketsAvailable from "apps/registration/components/ticket/noTicketsAvailable";

export default function CouponCodeForm() {
  const service = useCouponCodeService();
  const copies = useCopies();

  return (
    <React.Fragment>
      <div className="couponCodeForm">
        {service.couponCode ? (
          <CouponCodeReadOnly couponCode={service.couponCode} handleRemove={service.handleCouponCodeRemove} />
        ) : (
          <CouponCodeInput
            validationSchema={service.validationSchema}
            initialValues={service.initialValues}
            handleSubmit={service.handleSubmit}
            invalidCouponCode={service.invalidCouponCode}
          />
        )}
        {service.regFormList && service.regFormList.length > 0 && service.couponCode && (
          <React.Fragment>
            {service.regFormList.length > 1 && (
              <h4 className="text-center">{copies.get("select.reg.form.for.coupon.code")}</h4>
            )}
            <TicketList ticketList={service.regFormList} showSingleBuyButtonAtOnce />
          </React.Fragment>
        )}
        {service.couponCode && service.regFormList && !service.regFormList.length && <NoTicketsAvailable />}
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
}

function CouponCodeInput(props: CouponCodeFormProps) {
  const copies = useCopies();

  return (
    <FormContainer
      enableReinitialize
      initialValues={props.initialValues}
      validationSchema={props.validationSchema}
      onSubmit={props.handleSubmit}>
      {({ errors, values, touched }: AnyObject) => {
        return (
          <FormContainer.Form>
            <div className="couponCodeForm_input">
              <FormTextField label="" name="couponCode" placeholder={copies.get("enter.coupon.code")} required />
              <Button label={copies.get("apply")} type={ButtonType.SUBMIT} />
              {errors?.couponCode && touched.couponCode ? (
                <span className="form_error">
                  <ErrorMessage name={"couponCode"} />
                </span>
              ) : (
                props.invalidCouponCode === values.couponCode && (
                  <span className="form_error">{copies.get("invalid.coupon.code")}</span>
                )
              )}
            </div>
          </FormContainer.Form>
        );
      }}
    </FormContainer>
  );
}

function CouponCodeReadOnly(props: CouponCodeReadOnlyProp) {
  const copies = useCopies();
  return (
    <div className="couponCode_readOnly">
      <p>
        <span>{copies.get("coupon")}:</span> {props.couponCode}
        <Button
          variant={Variant.LINK}
          icon={<Icon.Close />}
          title={copies.get("remove.coupon")}
          onClick={() => {
            props.handleRemove(false);
          }}
        />
      </p>
    </div>
  );
}
